import { useState } from 'react';

export default function ContactSection() {
  const [formResult, setFormResult] = useState<{ success: boolean; message: string } | null>(null);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormResult({ success: true, message: '感谢您的留言，我们会尽快回复！' });
      form.reset();
      setCharCount(0);
      return;
    }

    try {
      const formUrl = 'https://readdy.ai/api/form/d9snu0tlbrt1qcgaj6mg';
      const formData = new FormData(form);
      if (honeypotEl) {
        formData.delete('phone_alt');
      }
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value.toString());
      });

      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormResult({ success: true, message: '感谢您的留言，我们会尽快回复！' });
        form.reset();
        setCharCount(0);
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        setFormResult({ success: false, message: serverMsg });
      }
    } catch {
      setFormResult({ success: false, message: '网络错误，请稍后重试' });
    }
  };

  return (
    <section className="py-10 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center">
          联系我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          如有任何疑问，欢迎随时与我们联系
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-10">
          <div>
            <div className="flex flex-col gap-5">
              <div className="flex items-start gap-4 bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg shrink-0">
                  <i className="ri-phone-line text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">客服热线</h4>
                  <p className="text-sm text-foreground-500 mt-1">400-888-6666</p>
                  <p className="text-xs text-foreground-400 mt-0.5">7×24小时服务</p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg shrink-0">
                  <i className="ri-mail-line text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">电子邮箱</h4>
                  <p className="text-sm text-foreground-500 mt-1">service@caikewang.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg shrink-0">
                  <i className="ri-map-pin-line text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">公司地址</h4>
                  <p className="text-sm text-foreground-500 mt-1">北京市海淀区中关村科技园区</p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg shrink-0">
                  <i className="ri-wechat-line text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">微信公众号</h4>
                  <p className="text-sm text-foreground-500 mt-1">caikewang_official</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
            <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-5">
              在线留言
            </h3>
            <form
              data-readdy-form="contact"
              onSubmit={handleSubmit}
              className="flex flex-col gap-4"
            >
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">
                  姓名
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">
                  邮箱
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">
                  留言内容
                </label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 transition-colors resize-none"
                  placeholder="请输入您的留言内容（不超过500字）"
                  onChange={(e) => setCharCount(e.target.value.length)}
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">{charCount}/500 个字符</p>
              </div>

              <input
                type="text"
                name="phone_alt"
                className="hp-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />

              <button
                type="submit"
                className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                提交留言
              </button>

              {formResult && (
                <div
                  className={`p-3 rounded-lg text-sm ${
                    formResult.success
                      ? 'bg-green-50 text-green-700 border border-green-200'
                      : 'bg-red-50 text-red-700 border border-red-200'
                  }`}
                >
                  {formResult.message}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}